import { GridLegacy as Grid, Stack } from '@mui/material';
import { SearchGrid } from '@/components/SearchGrid';
import { SMBold } from '@/typography/Typography';
import { SearchInput } from '@/components/shared/SearchInput';
import { useTranslation } from 'react-i18next';

export type InstaSignFiltersProps = {
    onSearchChange: (search: string) => void;
    onResetFilters: () => void;
    showResetFilter?: boolean;
};

export const InstaSignFilters = (props: InstaSignFiltersProps) => {
    const { t } = useTranslation();

    return (
        <SearchGrid container columnSpacing={1}>
            <Grid item xs={4}>
                <Stack
                    direction={'row'}
                    alignItems={'center'}
                    gap={1}
                    justifyContent={'space-between'}
                >
                    <div>
                        <SMBold noWrap={true}>{t('Filter by: ')}</SMBold>
                    </div>

                    <SearchInput
                        onDebouncedTextChange={props.onSearchChange}
                        placeholder={t('Search')}
                    />
                </Stack>
            </Grid>

            {/* <Grid item>
                <PrimaryButton onClick={resetFilters}>
                    <Typography
                        fontSize={'14px'}
                        lineHeight={'20px'}
                        fontWeight={600}
                        noWrap
                    >
                        {t('reset_filter')}
                    </Typography>
                </PrimaryButton>
            </Grid> */}
        </SearchGrid>
    );
};
